import React from "react";
import { IoBus } from "react-icons/io5";

export default function WatchBusSkeleton() {
  return (
    <div className="min-h-[calc(100vh-80px)] bg-[#f8f9ff] antialiased flex flex-col md:flex-row animate-pulse">
      <div className="w-full md:grow h-[45vh] md:h-[calc(100vh-80px)] bg-gray-200 flex items-center justify-center relative">
        <div className="text-center space-y-2">
          <div className="w-12 h-12 bg-gray-300 rounded-full mx-auto flex items-center justify-center text-gray-400">
            <IoBus className="text-2xl" />
          </div>
          <div className="h-4 bg-gray-300 rounded w-32 mx-auto"></div>
        </div>

        <div className="absolute top-4 left-4 bg-white px-4 py-2 rounded-xl h-12 w-28 md:hidden"></div>
      </div>

      <div className="w-full md:w-[420px] md:min-w-[420px] bg-white border-t md:border-t-0 md:border-l border-gray-100 flex flex-col h-full md:h-[calc(100vh-80px)] overflow-y-auto">
        <div className="p-5 border-b border-gray-50 bg-[#f8f9ff]/50 space-y-4">
          <div className="flex justify-between items-start">
            <div className="space-y-2">
              <div className="h-5 bg-gray-200 rounded w-20"></div>
              <div className="h-6 bg-gray-200 rounded w-36"></div>
            </div>
            <div className="space-y-1.5 flex flex-col items-end">
              <div className="h-3 bg-gray-200 rounded w-16"></div>
              <div className="h-4 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 border border-gray-100 h-16 flex items-center gap-4">
            <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
            <div className="space-y-2 flex-1">
              <div className="h-3 bg-gray-200 rounded w-16"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        </div>

        <div className="p-5 border-b border-gray-50 grid grid-cols-2 gap-4">
          <div className="bg-[#f8f9ff] p-3 rounded-xl space-y-2 h-16">
            <div className="h-3 bg-gray-200 rounded w-12"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
          <div className="bg-[#f8f9ff] p-3 rounded-xl space-y-2 h-16">
            <div className="h-3 bg-gray-200 rounded w-12"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </div>
        </div>

        <div className="p-5 border-b border-gray-50">
          <div className="p-3.5 bg-gray-50 rounded-xl h-16 flex items-center justify-between">
            <div className="flex items-center gap-3 flex-1">
              <div className="w-16 h-8 bg-gray-200 rounded-md"></div>
              <div className="space-y-2 flex-1">
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                <div className="h-2.5 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
            <div className="w-16 h-6 bg-gray-200 rounded-full"></div>
          </div>
        </div>

        <div className="p-5 grow">
          <div className="h-4 bg-gray-200 rounded w-36 mb-6"></div>
          <div className="relative pl-6 space-y-6 before:absolute before:left-[9px] before:top-2 before:bottom-2 before:w-[2px] before:bg-gray-100">
            {[1, 2, 3].map((n) => (
              <div
                key={n}
                className="relative flex flex-col items-start space-y-1.5"
              >
                <span className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-gray-200" />
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
